import React from 'react';
import { colorType, withTheme } from '../styling/theme';

const FriendIcon = ({ grayColor }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
    <g>
      <path
        d="M256 0C114.841 0 0 114.841 0 256s114.841 256 256 256 256-114.841 256-256S397.159 0 256 0m0 480C132.486 480 32 379.514 32 256S132.486 32 256 32s224 100.486 224 224-100.486 224-224 224m137.549-152.8a177.963 177.963 0 0 1-275.1 0 16 16 0 1 1 24.721-20.319 145.963 145.963 0 0 0 225.657 0 16 16 0 0 1 24.721 20.319zM293.136 211.755V200.5c0-23.566 21.982-42.738 49-42.738s49 19.172 49 42.738v11.26a16 16 0 0 1-32 0V200.5c0-5.069-7.271-10.738-17-10.738s-17 5.669-17 10.738v11.26a16 16 0 1 1-32 0zm-172.277 0V200.5c0-23.566 21.983-42.738 49-42.738s49 19.172 49 42.738v11.26a16 16 0 0 1-32 0V200.5c0-5.069-7.27-10.738-17-10.738s-17 5.669-17 10.738v11.26a16 16 0 1 1-32 0z"
        fill={grayColor.hex}
        opacity="1"
        data-original="#000000"
      />
    </g>
  </svg>
);

FriendIcon.propTypes = {
  grayColor: colorType,
};

FriendIcon.defaultProps = {
  grayColor: {},
};

export default withTheme(({ colors: { gray } }) => ({
  grayColor: gray,
}))(FriendIcon);
